import deployMeta from '@scoutgg/ftw/source/services/deploy-meta'
import ftw from '@scoutgg/ftw/source/services/config'
import moment from 'moment'
import './components'
import './routes'

moment.locale('en')
function ftwConfig() {
  const script = document.head.querySelector('script[src="/assets/main.js"]')
  ftw.ws = script?.dataset?.ws || 'https://fanteam-game.ws.scoutgg-stg.net'
  ftw.root = script?.dataset?.root || location.origin
  ftw.models.primaryKey = {
    name: '_id',
    type: String,
  }
  window.ftWidgets = { config: ftw }

  var tokenNode = document.querySelector('meta[name=token]')
  if(tokenNode) {
    ftw.token = tokenNode.getAttribute('content')
    ftw.whiteLabel = 'sportyman'
    ftw.assetHost = 'https://fantasy.assets.scoutgg.net'
  }
}

ftwConfig()

const $html = document.documentElement

$html.classList.toggle('dark-mode', !!localStorage.darkTheme)

document.addEventListener('DOMContentLoaded', () => {
  const $theme = document.getElementById('theme')
  if(!$theme) return
  $theme.addEventListener('click', () => {
    if(localStorage.darkTheme) {
      delete localStorage.darkTheme
    } else {
      localStorage.darkTheme = true
    }

    $html.classList.toggle('dark-mode', !!localStorage.darkTheme)
  })
})

deployMeta()

if(module.hot) {
  module.hot.accept(ftwConfig)
}
